module.exports = __webpack_public_path__ + "i18n/tr.0ff171eaec1255adbf15799c89c5c33d.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 1546
// module chunks = 60